import { FilterObject } from 'src/app/dataLayer/ProductsModels/Helpers/FilterObject';
import { HttpClient } from "@angular/common/http";
import { Injectable } from "@angular/core";
import { Apollo } from "apollo-angular";
import { environment } from 'src/environments/environment';
import { FilterList, GET_PAYMENT_TYPES_QUERY, get_kasheir_payment_Query } from '../ProductsServices/products.query';
import { CookieService } from 'ngx-cookie-service';
import { BaseService, LanguageService } from 'imakeapp-shared';





@Injectable()
export class PaymentService extends BaseService
{



   constructor(
      private http: HttpClient,
      private apollo: Apollo,
      private cookie_s: CookieService,
      public override language_s: LanguageService
   ) {
     super(language_s);
   }



   GetFilterList(data:FilterObject)
   {


      return this.apollo.watchQuery({
         query: FilterList(data, this.lang),
         fetchPolicy: "no-cache"
      ,variables:data}).valueChanges;

   }

   get_payment_types()
   {


      return this.apollo.use("paymentService").watchQuery({
         query: GET_PAYMENT_TYPES_QUERY(this.lang),
         fetchPolicy: "no-cache"
      }).valueChanges;

   }


   check_voucher(body: any)
   {

      return this.http.post(`${environment.ApiEndPoint2}/vouchers/checkVoucher`, body);

   }

   get_hashing_kashier(body: any)
   {

      return this.http.post<any>(`https://imake-app.com:5111/api/kasheir/generateHashing`, body).toPromise();

   }
   add_order(body: any)
   {

      return this.http.post(`${environment.ApiEndPoint}/orders/add`, body);

   }


   add_order_using_paymob(body: any)
   {
      return this.http.post(`${environment.ApiEndPoint}/orders/addvisaorder`, body);
   }
   get_kasheir_payment_info()
   {
    return this.apollo.use("paymentService").watchQuery({
      query: get_kasheir_payment_Query(),
      fetchPolicy: "no-cache"
   }).valueChanges;
   }



}

